{ "imageTag": "1.54.0-9", "buildUri": "vstfs:///Build/Build/103661", "buildId": "103661", "sourceCommit": "1f4af91f8b3c7394ec918dfa4a672e250f310621", "sourceBranch": "release/1.54.0", "releaseDate": "2026-11-03T05:10:12Z" }
